const REDIRECT_KEY = 'urlredirect';

/**
 * Remembers where an anonymous visitor was heading, so login can send them back.
 *
 * This logic used to live in the body of LocalizedApp's render(). It was idempotent, so
 * nothing broke, but writing to localStorage while rendering is a render-phase side
 * effect: React may render speculatively and discard the result without committing,
 * which would persist a redirect for a screen the user never saw. It is now called from
 * componentDidMount and componentDidUpdate, after the commit.
 *
 * Pulled out as a pure function rather than a private method so it can be tested without
 * mounting the entire application tree.
 */
export function rememberRedirectTarget(isSignedIn: boolean, href: string, pathname: string): void {
  if (isSignedIn) {
    return;
  }

  const isLoginPage = href.split('login').length !== 1;
  const isRootPath = pathname.split('/')[1] === '';

  if (isLoginPage || isRootPath) {
    localStorage.removeItem(REDIRECT_KEY);
    return;
  }

  // The dataporten callback is a waypoint in the login flow, never a destination.
  if (href.split('dataporten').length === 1) {
    localStorage.setItem(REDIRECT_KEY, href);
  }
}
